<template>
	<ClientTeleport>
		<Transition name="fade">
			<Modal
				v-if="isOpen"
				@update:is-open="newValue => isOpen = newValue"
			>
				<div class="pb-8 pt-24">
					<div class="flex justify-center mb-10">
						<NuxtIcon :name="stateInfo.icon.name || 'tool'" filled class="text-8xl text-icon-primary" />
					</div>
					<div class="typo-body-xl text-center text-body-secondary mb-6 rem:max-w-[614px] mx-auto">
						{{ stateInfo.title }}
					</div>
					<p class="text-center mb-8 rem:max-w-[614px] mx-auto">
						{{ stateInfo.text }}
					</p>
					<div class="flex justify-center">
						<button
							type="button"
							class="btn btn-primary btn-lg px-16"
							@click="isOpen = false"
						>
							Ok, rozumím
						</button>
					</div>
				</div>
			</Modal>
		</Transition>
	</ClientTeleport>
</template>

<script setup lang="ts">
	import type {StateInfoStoryblok} from '@/storyblok/types';

	interface Props {
		stateInfo: StateInfoStoryblok
	}
	defineProps<Props>();

	const isOpen = ref(true);

	watch(isOpen, () => {
		if (isOpen.value) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'scroll';
		}
	});
</script>
